import { ButtonListItem, List, NavLink, Stack } from "@fideus-ui/core";
import {
  AccountBalance,
  Article,
  Business,
  Checklist,
  Logout as LogoutIcon,
  People,
  Person,
  Terminal,
} from "@fideus-ui/core/icons";
import { useNavigate } from "@tanstack/react-router";
import { useIsFeatureEnabled } from "../_app/featureFlags";
import { useTranslation } from "../_app/i18n";
import { translations } from "./translations";

export function ServiceMenu() {
  const t = useTranslation(translations);
  const navigate = useNavigate();
  const isManageServiceUsersEnabled = useIsFeatureEnabled("manageServiceUsers");
  const isManageTaxAdvisorsEnabled = useIsFeatureEnabled("manageTaxAdvisors");
  const isRunServiceScriptsEnabled = useIsFeatureEnabled("runServiceScripts");
  const isManageProcessErrorsEnabled = useIsFeatureEnabled(
    "manageProcessErrors"
  );
  const isCreateOfferEnabled = useIsFeatureEnabled("createOffer");
  return (
    <Stack direction="column">
      <List sx={{ flexGrow: 1 }}>
        <NavLink to="/firmen" icon={<Business />} label={t("companies")} />

        <NavLink to="/kunden" icon={<People />} label={t("clients")} />

        <NavLink to="/vorgaenge" icon={<Checklist />} label={t("processes")} />
        {isManageProcessErrorsEnabled && (
          <NavLink
            to="/jahresabschluesse"
            icon={<Article />}
            label={t("annualStatements")}
          />
        )}
        {isManageServiceUsersEnabled && (
          <NavLink to="/nutzer" icon={<Person />} label={t("users")} />
        )}
        {isManageTaxAdvisorsEnabled && (
          <NavLink
            to="/steuerberater"
            icon={<AccountBalance />}
            label={t("taxAdvisors")}
          />
        )}
        {isCreateOfferEnabled && (
          <NavLink
            to="/angebot-erstellen"
            icon={<Article />}
            label={t("createOffer")}
          />
        )}
        {isRunServiceScriptsEnabled && (
          <NavLink to="/scripts" icon={<Terminal />} label={t("scripts")} />
        )}

        <ButtonListItem
          onClick={() => navigate({ to: "/abmelden" })}
          icon={<LogoutIcon />}
          label={t("logout")}
        />
      </List>
    </Stack>
  );
}
